(function () {
  'use strict';
 
  var CONFIG = Object.assign({
    freeShippingThreshold: 6500,
    freeGiftThreshold:     6500,
    upsellHandles: [
      'olive-leaf-extract',
      'black-cumin-seed-oil-capsules',
      'tart-cherry-capsules',
      'gelatinized-maca-root-capsules'
    ]
  }, window.SLNCartConfig || {});
 
  var cart = null;
  var upsellProducts = [];
  var upsellsLoaded = false;
 
  var drawer        = document.getElementById('sln-cart-drawer');
  var overlay       = document.getElementById('sln-cart-overlay');
  var closeBtn      = document.getElementById('sln-cart-close');
  var continueBtn   = document.getElementById('sln-cart-continue');
  var itemsList     = document.getElementById('sln-cart-items');
  var emptyState    = document.getElementById('sln-cart-empty');
  var countEl       = document.getElementById('sln-cart-count');
  var subtotalEl    = document.getElementById('sln-subtotal');
  var progressFill  = document.getElementById('sln-progress-fill');
  var progressBar   = document.getElementById('sln-progress-bar');
  var progressMsg   = document.getElementById('sln-progress-msg');
  var milestoneShip = document.getElementById('sln-milestone-shipping');
  var milestoneGift = document.getElementById('sln-milestone-gift');
  var footerNote    = document.getElementById('sln-footer-note');
  var upsellScroll  = document.getElementById('sln-upsells-scroll');
  var upsellSection = document.getElementById('sln-upsells');
  var toastEl       = document.getElementById('sln-toast');
  var checkoutBtn   = document.getElementById('sln-checkout-btn');
 
  function openCart() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('drawer-open');
    fetchCart();
  }
 
  function closeCart() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    document.body.classList.remove('drawer-open');
  }
 
  function fetchCart() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        cart = data;
        renderCart();
      });
  }
 
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
 
  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
 
  function renderCart() {
    if (!cart) return;
 
    if (countEl) countEl.textContent = cart.item_count;
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
 
    var hasItems = cart.items && cart.items.length > 0;
    if (emptyState) emptyState.hidden = hasItems;
 
    var existing = itemsList ? itemsList.querySelectorAll('.sln-cart-item') : [];
    for (var i = 0; i < existing.length; i++) {
      existing[i].parentNode.removeChild(existing[i]);
    }
 
    if (hasItems && itemsList) {
      for (var j = 0; j < cart.items.length; j++) {
        var el = buildItemEl(cart.items[j]);
        itemsList.insertBefore(el, emptyState);
      }
    }
 
    updateProgress(cart.total_price);
 
    var away = CONFIG.freeShippingThreshold - cart.total_price;
    if (footerNote) {
      if (cart.total_price >= CONFIG.freeShippingThreshold) {
        footerNote.textContent = '✓ Free shipping applied!';
        footerNote.classList.add('is-unlocked');
      } else {
        footerNote.textContent = 'Add ' + formatMoney(away) + ' more for free shipping';
        footerNote.classList.remove('is-unlocked');
      }
    }
 
    if (!upsellsLoaded) {
      upsellsLoaded = true;
      loadUpsells();
    } else {
      renderUpsells();
    }
  }
 
  function buildItemEl(item) {
    var el = document.createElement('div');
    el.className = 'sln-cart-item';
    el.dataset.key = item.key;
 
    var imgSrc = item.image || '';
    if (imgSrc) {
      imgSrc = imgSrc.replace('.jpg', '_120x120.jpg').replace('.png', '_120x120.png');
    }
 
    var variantTitle = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
 
    el.innerHTML =
      '<div class="sln-cart-item__image-wrap">' +
        (imgSrc ? '<img src="' + imgSrc + '" alt="' + escapeHtml(item.product_title) + '" width="68" height="68" loading="lazy">' : '') +
      '</div>' +
      '<div class="sln-cart-item__details">' +
        '<p class="sln-cart-item__title">' + escapeHtml(item.product_title) + '</p>' +
        '<p class="sln-cart-item__variant">' + escapeHtml(variantTitle) + '</p>' +
        '<div class="sln-cart-item__bottom">' +
          '<div class="sln-qty">' +
            '<button class="sln-qty__btn sln-qty__minus" aria-label="Decrease quantity">-</button>' +
            '<span class="sln-qty__num">' + item.quantity + '</span>' +
            '<button class="sln-qty__btn sln-qty__plus" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<div class="sln-cart-item__price-wrap">' +
            '<span class="sln-cart-item__price">' + formatMoney(item.line_price) + '</span>' +
            '<button class="sln-cart-item__remove" aria-label="Remove item">&#x2715;</button>' +
          '</div>' +
        '</div>' +
      '</div>';
 
    var key = item.key;
    var qty = item.quantity;
 
    el.querySelector('.sln-qty__minus').addEventListener('click', function() { updateQty(key, qty - 1); });
    el.querySelector('.sln-qty__plus').addEventListener('click', function() { updateQty(key, qty + 1); });
    el.querySelector('.sln-cart-item__remove').addEventListener('click', function() {
      el.classList.add('is-removing');
      setTimeout(function() { updateQty(key, 0); }, 200);
    });
 
    return el;
  }
 
  function updateQty(key, qty) {
    if (qty < 0) qty = 0;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      cart = data;
      renderCart();
    });
  }
 
  function addToCart(variantId, quantity) {
    quantity = quantity || 1;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.status) {
        showToast('Error adding item. Please try again.');
        return;
      }
      fetchCart();
      openCart();
    });
  }
 
  function updateProgress(totalCents) {
    var max = CONFIG.freeShippingThreshold;
    var pct = Math.min(100, (totalCents / max) * 100);
    var shipUnlocked = totalCents >= CONFIG.freeShippingThreshold;
 
    if (progressFill) progressFill.style.width = pct + '%';
    if (progressBar) progressBar.setAttribute('aria-valuenow', Math.round(pct));
    if (milestoneShip) milestoneShip.classList.toggle('is-unlocked', shipUnlocked);
    if (milestoneGift) milestoneGift.classList.toggle('is-unlocked', shipUnlocked);
 
    if (progressMsg) {
      var away = Math.max(0, CONFIG.freeShippingThreshold - totalCents);
      if (shipUnlocked) {
        progressMsg.innerHTML = '&#x1F69A; <strong>Free shipping unlocked!</strong>';
      } else {
        progressMsg.innerHTML = 'You\'re <strong>' + formatMoney(away) + '</strong> away from <strong>Free Shipping</strong> &#x1F69A;';
      }
    }
  }
 
  function loadUpsells() {
    if (!upsellSection || !upsellScroll) return;
 
    var handles = CONFIG.upsellHandles;
    if (!handles || handles.length === 0) {
      upsellSection.style.display = 'none';
      return;
    }
 
    var promises = handles.map(function(h) {
      return fetch('/products/' + h + '.js')
        .then(function(r) { return r.ok ? r.json() : null; })
        .catch(function() { return null; });
    });
 
    Promise.all(promises).then(function(results) {
      upsellProducts = results.filter(function(p) { return p !== null; });
      renderUpsells();
    });
  }
 
  function renderUpsells() {
    if (!upsellSection || !upsellScroll) return;
 
    if (upsellProducts.length === 0) {
      upsellSection.style.display = 'none';
      return;
    }
 
    var cartVariantIds = (cart && cart.items) ? cart.items.map(function(i) { return i.variant_id; }) : [];
 
    var filtered = upsellProducts.filter(function(p) {
      return p.variants && p.variants[0] && cartVariantIds.indexOf(p.variants[0].id) === -1;
    });
 
    if (filtered.length === 0) {
      upsellSection.style.display = 'none';
      return;
    }
 
    upsellSection.style.display = '';
    upsellScroll.innerHTML = '';
 
    filtered.forEach(function(product) {
      var variant = product.variants[0];
      if (!variant) return;
 
      var card = document.createElement('div');
      card.className = 'sln-upsell-card';
 
      var imgSrc = product.images && product.images[0] ? product.images[0] : '';
      if (imgSrc) {
        imgSrc = imgSrc.replace('.jpg', '_120x120.jpg').replace('.png', '_120x120.png');
      }
 
      card.innerHTML =
        (imgSrc
          ? '<img class="sln-upsell-card__img" src="' + imgSrc + '" alt="' + escapeHtml(product.title) + '" width="64" height="64" loading="lazy">'
          : '<div class="sln-upsell-card__img"></div>'
        ) +
        '<div class="sln-upsell-card__info">' +
          '<p class="sln-upsell-card__name">' + escapeHtml(product.title) + '</p>' +
          '<p class="sln-upsell-card__price">' + formatMoney(variant.price) + '</p>' +
        '</div>' +
        '<button class="sln-upsell-card__btn">+ Add</button>';
 
      var variantId = variant.id;
      var title = product.title;
 
      card.querySelector('.sln-upsell-card__btn').addEventListener('click', function() {
        this.textContent = 'Added!';
        this.classList.add('is-added');
        this.disabled = true;
        addToCart(variantId, 1);
        showToast(title + ' added to cart!');
      });
 
      upsellScroll.appendChild(card);
    });
  }
 
  var toastTimer = null;
  function showToast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function() {
      toastEl.classList.remove('is-visible');
    }, 2600);
  }
 
  if (closeBtn) closeBtn.addEventListener('click', closeCart);
  if (overlay) overlay.addEventListener('click', closeCart);
  if (continueBtn) continueBtn.addEventListener('click', closeCart);
 
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeCart();
  });
 
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form.matches('[action="/cart/add"]')) return;
    e.preventDefault();
 
    var formData = new FormData(form);
    var variantId = formData.get('id');
    var quantity = parseInt(formData.get('quantity') || '1', 10);
    if (!variantId) return;
 
    var submitBtn = form.querySelector('[type="submit"]');
    var originalText = submitBtn ? submitBtn.innerHTML : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = 'Adding...';
    }
 
    addToCart(variantId, quantity);
 
    if (submitBtn) {
      setTimeout(function() {
        submitBtn.innerHTML = originalText;
        submitBtn.disabled = false;
      }, 1000);
    }
  });
 
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[href="/cart"], [data-sln-cart-trigger]');
    if (trigger) {
      e.preventDefault();
      openCart();
    }
  });
 
  window.SLNCart = {
    open:      openCart,
    close:     closeCart,
    addToCart: addToCart,
    refresh:   fetchCart,
    toast:     showToast
  };
 
  fetchCart();
 
})();
 